module.exports = __webpack_public_path__ + "static/media/ucc.708105fb.png";